var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.0589 11.1994L10.6171 7.59616H7.12702V5.25789C7.12702 4.27211 7.61456 3.31122 9.17767 3.31122H10.7643V0.243432C10.7643 0.243432 9.32448 0 7.94783 0C5.07363 0 3.19491 1.7258 3.19491 4.84997V7.59616H0V11.1994H3.19491V19.9101H7.12702V11.1994H10.0589Z","fill":"white"}));
}

FacebookIcon.defaultProps = {"width":"11","height":"20","viewBox":"0 0 11 20","fill":"none"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
